import "./app.css";
import "flowbite";

// Modules
import "./modules/front-page.css";
import "./modules/products.css";
import "./modules/brands.css";
import "./modules/influencer-listing.css";
import "./modules/about.css";
import "./modules/mobile.css";

import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

window.Alpine = Alpine;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("alpine:init", () => {
  Alpine.store("siteData", {
    isAdminBarShowing: $HIIP_PAGE_DATA.IS_ADMIN_BAR_SHOWING,
  });

  Alpine.store("hiipData", {
    regions: [
      {
        id: "vn",
        label: "Vietnam",
        flag: "vn.svg",
      },
      {
        id: "sg",
        label: "Singapore",
        flag: "sg.svg",
      },
      {
        id: "id",
        label: "Indonesia",
        flag: "id.svg",
      },
      {
        id: "th",
        label: "Thailand",
        flag: "id.svg",
      },
      {
        id: "ph",
        label: "Philippines",
        flag: "ph.svg",
      },
    ],

    languages: [
      {
        id: "vi",
        label: "Tiếng Việt",
      },
      {
        id: "vi",
        label: "English",
      },
    ],
  });
});

Alpine.start();
Alpine.plugin(intersect);
